import React from 'react'
import moment from 'moment';

import PropTypes from 'prop-types';

import { Views } from 'react-big-calendar';

import styles from '../Agenda.module.css';
import { colors } from '../../../types/types';

export const Event = ({ event, currentView }) => {

    const hora = `${moment(event.start).format('HH:mm')} – ${moment(event.end).format('HH:mm')}`;

    return (
        <div className={styles.eventContainer}>
            <span className={styles.eventTime}>{hora}</span>

            {(typeof event.paciente !== 'undefined') &&
            <div className={styles.circleContainer}>
                <div className={styles.circle} style={{backgroundColor: event.paciente.colorApp}}></div>
            </div>
            }

            <div className={styles.eventText}>
                {`${ event.title }${ (typeof event.paciente !== 'undefined') ? ' - ' + event.paciente.edad : '' }${ (typeof event.motivoConsulta !== 'undefined' && event.motivoConsulta !== '') ? ` - ${ event.motivoConsulta }` : '' } - ${ event.motivo.nombre }`}
                {(currentView === Views.DAY) &&
                    (event.evento)
                        ? <span className={styles.badge + " " + styles.badgeRight + " badge"} style={{backgroundColor: colors.EVENT_COLOR}}>Evento</span>
                        : <span className={styles.badge + " " + styles.badgeRight + " badge"} style={{backgroundColor: event.colorCita}}>{ event.etiquetaCita }</span>
                }
            </div>
        </div>
    )
}

Event.propTypes = {
    event: PropTypes.any.isRequired,
}